import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { processSteps } from './data/processData'; // Adjusted path
import './WorkProcess.css';

gsap.registerPlugin(ScrollTrigger);

const WorkProcess = () => {
  const sectionRef = useRef(null);
  const gridRef = useRef(null);
  const titleRef = useRef(null);

  useEffect(() => {
    if (!sectionRef.current || !gridRef.current || !titleRef.current) return;

    let ctx = gsap.context(() => {
      // Animate the title
      gsap.from(titleRef.current, {
        opacity: 0,
        y: 30,
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: titleRef.current,
          start: 'top 90%', // Start when title top is 90% from viewport top
          toggleActions: 'play none none none',
          // markers: process.env.NODE_ENV === 'development', // Uncomment for debugging
        }
      });

      const items = gsap.utils.toArray(gridRef.current.children);

      if (items.length === 0) return;

      gsap.from(items, {
        opacity: 0,
        y: 50, // Start slightly lower
        duration: 0.8,
        ease: 'power2.out',
        stagger: 0.2, // Stagger the start of each item's animation
        scrollTrigger: {
          trigger: gridRef.current,
          start: 'top 85%', // Start when grid top is 85% from viewport top
          // end: 'bottom 20%', // Optional: if you want it to trigger only once and not replay on scroll back
          toggleActions: 'play none none none', // Play once on enter
          // markers: process.env.NODE_ENV === 'development', // Uncomment for debugging
        }
      });

    }, sectionRef); // Scope GSAP animations to this component

    // Cleanup
    return () => ctx.revert();

  }, []);

  return (
    <section className="work-process-section pro-elegant-light" ref={sectionRef}>
      <div className="container">
        <h2 className="section-title pro-title" ref={titleRef}>Our Work Process</h2>
        <div className="process-grid" ref={gridRef}>
          {processSteps.map((step) => (
            <div className="process-item" key={step.number}>
              <span className="process-number">{step.number}</span>
              <h3 className="process-heading">{step.title}</h3>
              <p className="process-description">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WorkProcess;